import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
} from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import "./DocumentMasterTable.css";
// import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const DocumentMasterTable = ({ isLoading, data, headers }) => {
  const [orderBy, setOrderBy] = useState("document_id");
  const [order, setOrder] = useState("asc");
  const [copiedItemId, setCopiedItemId] = useState(null);
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [selectedNote, setSelectedNote] = useState("");

  const handleSort = (column) => {
    if (orderBy === column && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setOrderBy(column);
  };

  const handleCopyClick = (event, id) => {
    navigator.clipboard.writeText(id);
    setCopiedItemId(id);
  };

  const handleOpenNoteDialog = (note) => {
    setSelectedNote(note);
    setOpenNoteDialog(true);
  };

  const handleCloseNoteDialog = () => {
    setOpenNoteDialog(false);
    setSelectedNote("");
  };

  const sortedData = data.sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] > b[orderBy] ? 1 : -1;
    } else {
      return a[orderBy] < b[orderBy] ? 1 : -1;
    }
  });

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {headers?.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    py: 0,
                    px: 1,
                    fontWeight: "bold",
                    color: "rgba(0, 0, 0, 0.87)",
                    width: "auto",
                  }}
                >
                  <TableSortLabel
                    active={orderBy === header}
                    direction={orderBy === header ? order : "asc"}
                    onClick={() => handleSort(header)}
                    sx={{ fontSize: "0.8rem" }}
                  >
                    {header}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={headers.length}>Loading...</TableCell>
              </TableRow>
            ) : sortedData.length > 0 ? (
              sortedData?.map((row) => (
                <TableRow key={row.document_id}>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <Tooltip
                        title={
                          copiedItemId === row.document_id
                            ? "Copied!"
                            : "Copy Document ID"
                        }
                        arrow
                      >
                        <IconButton
                          size="small"
                          onClick={(event) =>
                            handleCopyClick(event, row.document_id)
                          }
                          sx={{ 
                            padding: "2px",
                            "& .MuiSvgIcon-root": {
                              fontSize: "0.875rem",
                              color: "#9e9e9e",
                            },
                            "&:hover .MuiSvgIcon-root": {
                              color: "#757575",
                            },
                          }}
                        >
                          <FileCopyIcon />
                        </IconButton>
                      </Tooltip>
                      <span>{row.document_id.substring(0, 7) + "..."}</span>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.country}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.name || "-"}
                  </TableCell>
                  {/* <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                 
                    {row.note ? row.note.substring(0, 6) + "..." : "-"}
                    {row.note && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleOpenNoteDialog(row.note)}
                        sx={{ ml: 1 }}
                        style={{ padding: "0px" }}
                      >
                        View
                      </Button>
                    )}
                  </TableCell> */}
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.note ? (
                      <Tooltip title={row.note} arrow>
                        <span>
                          {row.note.substring(0, 6) + "..."}
                          <InfoOutlinedIcon
                            sx={{
                              ml: 1,
                              fontSize: "0.8rem",
                              verticalAlign: "middle",
                              color: "action.active",
                            }}
                          />
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.category}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.has_expired ? "Yes" : "No"}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.required ? "Yes" : "No"}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.verify_id || "-"}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.verification_required ? "Yes" : "No"}
                  </TableCell>
                  <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                    {row.type || "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={headers.length}>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog to show full note */}
      <Dialog open={openNoteDialog} onClose={handleCloseNoteDialog}>
        <DialogTitle>Full Note</DialogTitle>
        <DialogContent>
          <div>{selectedNote}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNoteDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DocumentMasterTable;
